/* Слайдеры */

import {throttle, fixToIntPixel, randomInt, loadLibrary} from './Util';
import {actualizeTabHeight} from './Tabs';
import {LIB_URL} from '../App';

const Slider = (root, options) => {
    const container = root.querySelector('.swiper-container');
    const next = root.querySelector('.js-slider-next');
    const prev = root.querySelector('.js-slider-prev');
    const pagination = root.querySelector('.js-slider-pagination');
    const bulletClass = 'slider__pagination-item';
    const bulletClassActive = 'slider__pagination-item--active';
    const slidesCount = root.querySelectorAll('.swiper-slide').length;
    let dynamicBulletsBool = false;
    if (App.H.hasClass('page-constructor')) {
        dynamicBulletsBool = true;
    }
    const defaults = {
        slidesPerView: 1,
        navigation: {
            prevEl: prev,
            nextEl: next
        },
        pagination: {
            el: pagination,
            bulletClass: bulletClass,
            bulletActiveClass: bulletClassActive,
            clickable: true,
            dynamicBullets: dynamicBulletsBool,
        },
        on: {
            transitionEnd: function() {
                fixToIntPixel(this);
            }
        },
        grabCursor: true,
    };
    const onResize = function () {
        let slidesPerView = getSlidesPerView(options);

        if (slidesPerView == 'auto' || slidesPerView < slidesCount) {
            if (!swiper) {
                swiper = new Swiper(container, options);
                root.classList.remove('_controls-off');
                swiper.on('slideChange', updateNavDataIndexes);
                updateNavDataIndexes(swiper);
            }
        } else {
            if (swiper) {
                swiper.destroy(false);
                swiper = undefined;
                root.classList.add('_controls-off');
                swiper.off('slideChange', updateNavDataIndexes);
            }
        }
    };
    let swiper;

    root.classList.add('_controls-off');
    options = Object.assign(defaults,options);
    onResize();

    window.addEventListener('resize', throttle(onResize, 200));
    return swiper;
};

function updateNavDataIndexes(swiper) {
    if (swiper.navigation && swiper.navigation.$nextEl && swiper.navigation.$nextEl.length) {
        $(swiper.navigation.$nextEl[0]).attr('data-active-slide', swiper.realIndex + 1);
    }
    if (swiper.navigation && swiper.navigation.$prevEl && swiper.navigation.$prevEl.length) {
        $(swiper.navigation.$prevEl[0]).attr('data-active-slide', swiper.realIndex + 1);
    }
}

function getSlidesPerView(options) {
    if (options.breakpoints) {
        let breakpoints = Object.keys(options.breakpoints).sort((a, b) => {if (+a > +b) return -1; if (+a == +b) return 0; if (+a < +b) return 1;});

        for (let i = 0; i < breakpoints.length; i++) {
            if (window.innerWidth >= breakpoints[i]) return options.breakpoints[breakpoints[i]].slidesPerView || 1;
        }
    }
    return options.slidesPerView || 1;
}

export default Slider;

// Инициализация всех имеющихся слайдеров
function initSliders() {
    // страндартный слайдер
    $('.js-slider').each(function () {
        new Slider(this);
    });

    $('.js-slider-banner,.js-slider-text-block').each(function () {
        const autoHeightBool = $(this).is('[data-autoheight]');
        const controller = $($(this).data('controller'));

        let sliderLoop = !$(this).is('[data-noloop]');
        if (App.H.hasClass('page-constructor')) {
            sliderLoop = false;
        }
        const defaultOptions = {
            loop: sliderLoop,
            threshold: 10,
            spaceBetween: 30,
            autoHeight: autoHeightBool,
            on: {
                slideChangeTransitionEnd: function () {
                    App.W.trigger('actualizeTabHeight');
                    let $sliderVitrum = $('.slider-vitrum');
                    if($sliderVitrum.length) {
                        let prevSlideName = $sliderVitrum.find('.swiper-slide-prev').data('name');
                        let nextSlideName = $sliderVitrum.find('.swiper-slide-next').data('name');
                        let prevSlideNameLastPos = $sliderVitrum.find('.swiper-slide-duplicate-next').data('name');
                        let nextSlideNameLastPos = $sliderVitrum.find('.swiper-slide-duplicate-active+.swiper-slide').data('name');
                        let slidesLength = $sliderVitrum.find('.swiper-slide').length;
                        if ($sliderVitrum.find('.swiper-slide.swiper-slide-active').attr('aria-label') === slidesLength + ' / ' + slidesLength) {
                            $sliderVitrum.find('.js-slider-prev').find('b').text(prevSlideNameLastPos);
                            $sliderVitrum.find('.js-slider-next').find('b').text(nextSlideNameLastPos);
                        } else if ($sliderVitrum.find('.swiper-slide.swiper-slide-active').attr('aria-label') === '1 / ' + slidesLength) {
                            $sliderVitrum.find('.js-slider-prev').find('b').text($sliderVitrum.find('.swiper-slide[aria-label="' + (slidesLength - 2) + ' / ' + slidesLength + '"]').data('name'));
                            $sliderVitrum.find('.js-slider-next').find('b').text($sliderVitrum.find('.swiper-slide-duplicate-active+.swiper-slide').data('name'));
                        } else {
                            $sliderVitrum.find('.js-slider-prev').find('b').text(prevSlideName);
                            $sliderVitrum.find('.js-slider-next').find('b').text(nextSlideName);
                        }
                    }
                },
                afterInit: function (swiper) {
                    App.W.trigger('renderTabs');
                    $(swiper.el).on('click', '.swiper-slide-active .js-tab-title', function () {
                        $(swiper.el)
                            .find('.swiper-slide-duplicate-active')
                            .find('.js-tab-title')
                            .eq($(this).index())
                            .click();
                    });
                },
            },
        };
        let options = {};

        if (controller.length && controller[0].swiper) {
            options = {
                ...options,
                loop: false,
                enabled: false,
                grabCursor: false,
                simulateTouch: false
            };
        }

        const swiper = new Slider(this, {
            ...defaultOptions,
            ...options
        });

        if (controller.length && controller[0].swiper) {
            controller[0].swiper.controller.control = swiper;
        }
    });

    $('.js-slider-events').each(function () {
        new Slider(this);
    });

    $('.js-slider-news').each(function () {
        if( $(this).find('.swiper-slide').length > 1 ){
            const autoHeightBool = $(this).is('[data-autoheight]');

            let sliderLoop = !$(this).is('[data-noloop]');
            if (App.H.hasClass('page-constructor')) {
                sliderLoop = false;
            }
            new Slider(this, {
                loop: sliderLoop,
                autoHeight: autoHeightBool,
            });
        } else {
            $(this).addClass('no-slider');
        }
    });

    $('.js-slider-only-mobile').each(function () {
        if( App.W.outerWidth() < 768 ){
            let initSlide = 0;

            // начинать показ слайдера со слайда для определенной специальности
            if ($(this).is('[data-find-speciality]')) {
                let specialityLS = window.localStorage.getItem('speciality');
                let specializationURL = '';
                if (window.location.href.indexOf('?') > 0) {
                    let params = new URLSearchParams(document.location.search);
                    specializationURL = params.get('specialization');
                }

                $(this).find('.swiper-slide').each(function(ind, el) {
                    let $specialityBlock = $(this).find('.js-slide-speciality');
                    let dataSpeciality = $specialityBlock.is('[data-speciality]') ? $specialityBlock.data('speciality').split('|') : [];

                    if (dataSpeciality.length > 0 &&
                        (dataSpeciality.indexOf(specialityLS) >= 0 || dataSpeciality.indexOf(specializationURL) >= 0)) {
                        initSlide = ind;
                    }
                });
            };

            let swiperLoop = $(this).is('[data-loop]') ? true : false;

            $(this).removeClass('no-slider');
            new Slider(this, {
                loop: swiperLoop,
                slidesPerView: 1,
                initialSlide: initSlide,
                breakpoints: {
                    768: {
                        slidesPerView: 4
                    }
                }
            });
        } else {
            $(this).addClass('no-slider');
        }
    });

    $('.js-slider-products-flip,.js-slider-image-flip,.js-artra-issue-slider').each(function () {
        let sliderLoop = !$(this).is('[data-noloop]');
        new Slider(this, {
            loop: sliderLoop,
            slidesPerView: 1,
            spaceBetween: 30,
            breakpoints: {
                // when window width is >= 768px
                768: {
                    slidesPerGroup: 2,
                    slidesPerView: 2
                },
                // when window width is >= 1024px
                1024: {
                    slidesPerGroup: 3,
                    slidesPerView: 3
                },
                // when window width is >= 1280px
                1280: {
                    slidesPerGroup: 4,
                    slidesPerView: 4
                }
            }
        });
    });

    $('.js-slider-partners').each(function () {
        const customOptions = $(this).attr('data-options') ? JSON.parse($(this).attr('data-options')) : {};

        new Slider(this, {
            loop: false,
            slidesPerView: 1,
            spaceBetween: 30,
            breakpoints: {
                // when window width is >= 768px
                768: {
                    slidesPerGroup: 2,
                    slidesPerView: 2
                },
                // when window width is >= 1024px
                1024: {
                    slidesPerGroup: 3,
                    slidesPerView: 3
                },
                1279: {
                    slidesPerGroup: 3,
                    slidesPerView: 3
                },
                // when window width is >= 1280px
                1280: {
                    slidesPerGroup: 4,
                    slidesPerView: 4
                }
            },
            ...customOptions,
        });
    });

    $('.js-slider-partners-auto').each(function () {
        new Slider(this, {
            loop: false,
            slidesPerView: 'auto',
            spaceBetween: 16,
            breakpoints: {
                768: {
                    spaceBetween: 20,
                },
                1284: {
                    spaceBetween: 40,
                }
            }
        });
    });

    $('.js-slider-products-store').each(function () {
        let sliderLoop = !$(this).is('[data-noloop]');
        new Slider(this, {
            loop: sliderLoop,
            slidesPerView: 1,
            spaceBetween: 30,
            breakpoints: {
                // when window width is >= 1280px
                1280: {
                    slidesPerView: 2
                }
            },
            on: {
                afterInit: function () {
                    App.D.trigger('sliderProductsStore:rendered');
                },
            }
        });
    });

    $('.js-slider-specialists').each(function () {
        new Slider(this, {
            loop: false,
            slidesPerView: 1,
            // centeredSlides: true,
            breakpoints: {
                520: {
                    slidesPerView: 2,
                },
                768: {
                    slidesPerView: 4,
                }
            }
        });
    });

    $('.js-slider-mobile').each(function () {
        new Slider(this, {
            loop: false,
            slidesPerView: 1,
            breakpoints: {
                768: {
                    slidesPerView: 3
                }
            }
        });
    });

    $('.js-slider-mobile-4').each(function () {
        new Slider(this, {
            loop: false,
            slidesPerView: 1,
            breakpoints: {
                768: {
                    slidesPerGroup: 4,
                    slidesPerView: 4
                }
            }
        });
    });

    const $optionalSlider = $('.js-optional-slider');

    $optionalSlider.each(function (index, el) {
        const $currWrap = $(el);
        let $currWrapItems = $currWrap.find(' > *');
        let slides = '';

        if ($currWrapItems.length > 4) {
            $currWrapItems.each(function (index, el) {
                let currSlide = `<div class='swiper-slide'>${$(el).wrap('<div/>').parent().html()}</div>`;
                slides += currSlide;
            });

            $currWrap.html(`
                <div class="slider slider--fullwidth-large">
                    <div class="slider__inner">
                        <div class="swiper-container slider__container">
                            <div class="swiper-wrapper">
                                ${slides}
                            </div>
                        </div>
                        <div class="swiper-button-prev slider__nav js-slider-prev"></div>
                        <div class="swiper-button-next slider__nav js-slider-next"></div>
                    </div>
                </div>
            `);

            new Slider(this, {
                loop: false,
                slidesPerView: 1,
                spaceBetween: 30,
                breakpoints: {
                    // when window width is >= 768px
                    768: {
                        slidesPerGroup: 2,
                        slidesPerView: 2
                    },
                    // when window width is >= 1024px
                    1024: {
                        slidesPerGroup: 3,
                        slidesPerView: 3
                    },
                    // when window width is >= 1280px
                    1280: {
                        slidesPerGroup: 4,
                        slidesPerView: 4
                    }
                }
            });

            if ($currWrap.closest('.js-tabs').length) {
                actualizeTabHeight($currWrap.closest('.js-tabs'));
            }
        }
    });

    $('.js-mobile-slider-news-wrapper').each((i, rootDom) => {
        const TEMPLATE = () => `
            <div class="slider slider--fullwidth-large">
                <div class="slider__inner">
                    <div class="swiper-container slider__container">
                        <div class="swiper-wrapper"></div>
                    </div>
                    <div class="swiper-button-prev slider__nav js-slider-prev"></div>
                    <div class="swiper-button-next slider__nav js-slider-next"></div>
                </div>
                <div class="slider__pagination js-slider-pagination"></div>
            </div>
        `;
        const $root = $(rootDom);
        const $newsWrapper = $root.find('.news-wrapper');
        const $news =  $newsWrapper.find('.news-item');
        const mql = window.matchMedia('(max-width: 767px)');
        let isMobile = false;
        let swiper;

        mql.addEventListener('change', matchMediaHandler);

        if (mql.matches) {
            render();
        }

        function render() {
                $newsWrapper.append(TEMPLATE());
                $newsWrapper.find('.swiper-wrapper').append($news);
                $news.wrap('<div class="swiper-slide"></div>');

                swiper = new Slider($root.find('.slider')[0], {
                    loop: true,
                    autoHeight: true,
                    spaceBetween: 20,
                    slidesPerView: 1,
                });
        }

        function destroy() {
            if (isMobile) {
                isMobile = false;

                if (swiper) {
                    swiper.destroy();
                    $newsWrapper.append($news);
                    $root.find('.slider').remove();
                }
            }
        }

        function matchMediaHandler() {
            if (mql.matches) {
                render();
            } else {
                destroy();
            }
        }
    });

    $('.js-products-wrapper').each((i, rootDom) => {
        const $root = $(rootDom);
        const mql = window.matchMedia('(max-width: 767px)');
        const TEMPLATE = {
            slider: (slidesHtml) => `
                <div class="slider">
                    <div class="slider__inner">
                        <div class="swiper-container slider__container">
                            <div class="swiper-wrapper">${slidesHtml}</div>
                            <div class="swiper-pagination"></div>
                        </div>
                    </div>
                    <div class="slider__pagination js-slider-pagination"></div>
                </div>
            `,
            slide: (src) => `<div class="swiper-slide"><img class="swiper-lazy" data-src="${src}" alt=""></div>`
        };

        if ($root.hasClass('js-more-container')) {
            $root.on('loadMore', () => {
                if (mql.matches) {
                    bildGalleries();
                }
            });
        }

        mql.addEventListener('change', matchMediaHandler);

        if (mql.matches) {
            bildGalleries();
        }

        function matchMediaHandler() {
            if (mql.matches) {
                bildGalleries();
            } else {
                destroyGalleries();
            }
        }

        function bildGalleries() {
            $root.find('img[data-gallery]').each((i, mainImgDom) => {
                const $mainImg = $(mainImgDom);
                const $imgRoot = $mainImg.closest('.product-item__img');
                const $slider = $imgRoot.find('.slider');

                if (!$slider.length) {
                    const galleryData = $mainImg.data('gallery');
                    let $slider = $(TEMPLATE.slider(galleryData.map(src => TEMPLATE.slide(src)).join('')));

                    $slider.insertBefore($mainImg);

                    new Slider($slider[0], {
                        spaceBetween: 0,
                        slidesPerView: 1,
                        preloadImages: false,
                        lazy: {
                            loadPrevNext: true,
                        },
                        pagination: {
                            el: '.swiper-pagination',
                            type: 'bullets',
                            dynamicBullets: true,
                            dynamicMainBullets: 2,
                        },
                    });
                }
            });
        }

        function destroyGalleries() {
            $root.find('.js-store-product .product-item__img .slider').each((i, sliderDom) => {
                const swiperDom = sliderDom.querySelector('.swiper-container');

                if (swiperDom && swiperDom.swiper) {
                    swiperDom.swiper.destroy();
                    $(sliderDom).remove();
                }
            });
        }
    });

    $('.js-images-slider').each(function () {
        new Slider(this, {
            loop: true,
            slidesPerView: 1,
            grabCursor: true,
            pagination: {
              el: ".images-slider-pagination",
              type: "fraction",
            },
            navigation: {
              nextEl: ".images-slider-button-next",
              prevEl: ".images-slider-button-prev",
            },
        });
    });

    $('.js-slider-reviews').each(function() {
        const $sliderReviews = $(this);
        const reviewsQuantity = $(this).find('.swiper-slide').length;
        const sliderLoop = !$(this).is('[data-noloop]');
        const reviewsUrl = $(this).data('reviews');

        if (reviewsQuantity > 4){
            new Slider(this, {
                loop: sliderLoop,
                slidesPerView: 1,
                spaceBetween: 30,
                breakpoints: {
                    // when window width is >= 768px
                    768: {
                        slidesPerGroup: 2,
                        slidesPerView: 2
                    },
                    // when window width is >= 1024px
                    1024: {
                        slidesPerGroup: 3,
                        slidesPerView: 3
                    },
                    // when window width is >= 1280px
                    1280: {
                        slidesPerGroup: 4,
                        slidesPerView: 4
                    }
                },
                on: {
                    slideChange() {
                        const pageId = parseInt($sliderReviews.find('.js-slider-reviews-page').val());
                        const sliderPages = $sliderReviews.find('.js-slider-pagination').find('.slider__pagination-item');
                        let sliderPagesActive = 0;

                        $(sliderPages).each((ind, el) => {
                            if ($(el).hasClass('slider__pagination-item--active-main')) {
                                sliderPagesActive = ind;
                            }
                        });

                        if (sliderPages.length - sliderPagesActive <= 2) {
                            $.ajax({
                                url: reviewsUrl,
                                data: `pageReviews=${pageId + 1}`,
                                dataType: 'json',
                                type: 'GET',
                                cache: false,
                                success: (response) => {
                                    this.appendSlide(response.reviews);
                                    $sliderReviews.find('.js-slider-reviews-page').val(pageId + 1);
                                },
                                error: function() {
                                    // Ошибка отправки
                                    console.log('Произошла ошибка');
                                }
                            });
                        }
                    }
                },
            });
        } else {
            $(this).addClass('_no-slider');
        }
    });
}

// Инициализация всех имеющихся слайдеров по требованию
function initSlidersDeferred() {
    if ($('.swiper-wrapper').length) {
        loadLibrary(LIB_URL.SWIPER, initSliders);
    }
}

// Для IE ожидаем загрузки страницы и запускаем инит через таймаут, иначе неверно рассчитывается ширина и браузер криво отображает слайдеры
if (App.ie) {
    App.W.on('load', function () {
        setTimeout(function () {
            initSlidersDeferred();
        }, 200);
    });
} else {
    initSlidersDeferred();
}

/* У разных слайдеров кнопки навигации в разных местах, добавляем класс родителю, чтобы скрыть кнопки у всех возможных вариаций слайдеров (см. slider-banner.less) */
$('.slider-no-navigation').parent().addClass('slider-no-navigation');
// только для мобилок
$('.slider-no-navigation--mobile').parent().addClass('slider-no-navigation--mobile');

if ($('.js-random-article').length) {
    $('.js-random-article').each(function() {
        const randomQuantity = $(this).data('random-quantity') || 3;
        const slides = $(this).find('.swiper-slide');
        const sliderLength = slides.length;

        slides.each(function(ind, el) {
            $(el).addClass('hidden');
        });

        for (let i = 0; i < randomQuantity; i++) {
            const randomIndex = randomInt(0, sliderLength);
            console.log('slides random', randomIndex);
            console.log('slides elem', $(slides[randomIndex]));
            if ($(slides[randomIndex]).hasClass('hidden')) {
                $(slides[randomIndex]).removeClass('hidden');
            } else {
                i--;
            }
        }
    });
}
